module.exports = __webpack_public_path__ + "static/media/IMG_1460_cropped.d9bc01b9.jpg";